var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    class: 'page_' + _vm.lang
  }, [_c('VideoContainer', {
    attrs: {
      "currentPage": _vm.currentPage
    }
  }), _vm._v(" "), (_vm.page.home) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.home.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__top"
  }, [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.home.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.home.text_description,
      "isActive": _vm.isActive()
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-extra",
    class: {
      'animating': _vm.pageReady && _vm.isSubTitle() && _vm.subTitle
    }
  }, [_c('div', {
    staticClass: "home-extra__item"
  }, [_c('div', {
    staticClass: "home-extra__item-title animated-title"
  }, [_c('PageTitleContent', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.home.text_extra_title_1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "home-extra__item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.text_extra_content_1)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "home-extra__item"
  }, [_c('div', {
    staticClass: "home-extra__item-title animated-title"
  }, [_c('PageTitleContent', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.home.text_extra_title_2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "home-extra__item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.text_extra_content_2)
    }
  })])])], 1)])])]) : _vm._e(), _vm._v(" "), _c('About'), _vm._v(" "), _c('Portfolio'), _vm._v(" "), _c('PortfolioContent'), _vm._v(" "), _c('Founders'), _vm._v(" "), _c('FoundersContent'), _vm._v(" "), _c('Team'), _vm._v(" "), _c('TeamContent'), _vm._v(" "), _c('News'), _vm._v(" "), _c('PrivateEquity'), _vm._v(" "), _c('PrivateEquityContent'), _vm._v(" "), _c('Contacts'), _vm._v(" "), (_vm.page.home) ? _c('FooterComponent', {
    attrs: {
      "copyright": _vm.page.home.text_footer_copy,
      "madeIn": _vm.page.home.text_footer_made_in
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popupOpened),
      expression: "popupOpened"
    }],
    staticClass: "fader",
    on: {
      "click": function($event) {
        _vm.closePopup()
      }
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794f82cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 200
// module chunks = 0